import { useMemo } from "react";
import { useAppSelector } from "../../../../redux/hooks";
import { Skeleton } from "../../../common/skeleton/skeleton";
import { sortArray } from "../../../../utils";
import { CustomDetailsList } from "../../../common/customDetailsList/customDetailsList";
import { SkeletonSizes } from "../../../../common/constants";
import { QueuAssignmentImportColumn } from "./column/column";

export const QueuAssignmentImportList = () => {
    const { loading, data, sort } = useAppSelector((state) => state.assignmentQueueImportList);

    const renderColumns = () => {
        return QueuAssignmentImportColumn();
    };

    const newList = useMemo(() => {
        return data?.errors ? sortArray(data?.errors, sort) : [];
    }, [data?.errors, sort]);

    return loading ? (
        <Skeleton rows={SkeletonSizes.DEFAULT} />
    ) : (
        <CustomDetailsList
            data={newList}
            renderColumns={renderColumns}
            height={"calc(100vh - 9rem)"}
        />
    );
};
